import React from 'react';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { array, func, string } from 'prop-types';

import { Button, Modal, useDisclosure } from '../../../../../ps-aspect-design';
import { DATA_SOURCE, useElements } from '../../../../FieldFilters/FieldFilterService';
import { updateEmployeeFilters } from '../GeoDifferentialActions';

import './EmployeeFilter.scss';
import FieldFilters from '../../../../FieldFilters/FieldFilters';

EmployeeFilters.propTypes = {
  actions: {
    updateEmployeeFilters: func
  },
  currentFilters: array,
  categoryElements: {
    loading: false,
    loaded: false,
    elements: null
  },
  maid: string
};

const getMasterAccountID = state => state.session?.organization?.masterAccountId;

function EmployeeFilters(props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const masterAccountId = useSelector(getMasterAccountID);

  const { data: elements, isFetched, isFetching } = useElements(masterAccountId, 'employees', [
    DATA_SOURCE.ORG_EMPLOYEES,
    DATA_SOURCE.JOBS
  ]);

  const numberOfFilters = props.currentFilters?.length;
  const buttonText = numberOfFilters ? `Filter Employees (${numberOfFilters} Applied)` : 'Filter Employees';

  const onSave = filtersToSave => {
    props.actions.updateEmployeeFilters(filtersToSave);
    onClose();
  };

  const onCancel = () => {
    onClose();
  };

  return (
    <div className="apply-geo__employee-filters">
      <Button variant="secondary" onClick={onOpen}>
        {buttonText}
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} className="apply-geo__employee-filters-modal">
        <h3>Filter Employees</h3>
        <FieldFilters
          loading={isFetching}
          loaded={isFetched}
          elements={elements}
          currentFilters={props.currentFilters}
          noFilterPlaceholder="No Employee Filter Elements Found"
          onSave={onSave}
          onCancel={onCancel}
        />
      </Modal>
    </div>
  );
}

const mapStateToProps = ({ geoDifferential }) => ({
  currentFilters: geoDifferential.employeeFilters
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      updateEmployeeFilters
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeFilters);
